import { render, staticRenderFns } from "./ClubSettings.vue?vue&type=template&id=4ced71d8&scoped=true"
import script from "./ClubSettings.vue?vue&type=script&lang=js"
export * from "./ClubSettings.vue?vue&type=script&lang=js"
import style0 from "./ClubSettings.vue?vue&type=style&index=0&id=4ced71d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ced71d8",
  null
  
)

export default component.exports